import axios from "axios";
import { handleDemoRequest } from "../demo/handleDemoRequest";

// export const API_URL = import.meta.env.VITE_API_URL || 'http://localhost:3020'
export const API_URL = '/'

const API = axios.create({
    withCredentials: true,
    baseURL: API_URL,
})

/** Чи API на тому ж origin, що й фронт (можна ставити URL фото напряму в <img>). */
export const isSameOriginApi = () => {
    try {
        if (!API_URL || API_URL === "/" || String(API_URL).startsWith("/")) {
            return true;
        }
        const apiOrigin = new URL(API_URL, window.location.origin).origin;
        return apiOrigin === window.location.origin;
    } catch {
        return true;
    }
};

/** Абсолютний/коректний URL для статичних асетів API (фото тощо). */
export const resolveApiAssetUrl = (url) => {
    if (!url) return "";
    const s = String(url);
    if (/^https?:\/\//i.test(s) || s.startsWith("blob:") || s.startsWith("data:")) {
        return s;
    }
    const base =
        !API_URL || API_URL === "/"
            ? ""
            : String(API_URL).replace(/\/$/, "");
    const path = s.startsWith("/") ? s : `/${s}`;
    return `${base}${path}`;
};

const demoAdapter = async (config) => {
    const url = String(config.url || "").replace(/^\//, "");
    const method = config.method || "get";
    const body = config.data;

    const res = await handleDemoRequest({ method, url, body });
    return {
        data: res.data,
        status: res.status,
        statusText: res.statusText || "OK",
        headers: res.headers || {},
        config,
    };
};

API.interceptors.request.use((config) => {
    try {
        const isDemo = localStorage.getItem("isDemo") === "1"
        const url = String(config?.url || "")
        const isAuthEndpoint = url.includes("api/auth/login") || url.includes("api/auth/logout")
        const isKindergartenRegistryEndpoint =
            url.includes("api/kindergarten/profile/") ||
            url.includes("api/kindergarten/kindergartens")
        const isEQueueEndpoint = url.includes("api/kindergarten/equeue/")

        // In demo mode we still keep real auth endpoints to preserve real menu/permissions.
        if (isDemo && !isAuthEndpoint && !isKindergartenRegistryEndpoint && !isEQueueEndpoint) {
            config.adapter = demoAdapter;
        }
    } catch (e) {
    }
    return config;
})
export default API;
